import { render, staticRenderFns } from "./PriceCalculator.vue?vue&type=template&id=91a5039a"
import script from "./PriceCalculator.vue?vue&type=script&lang=js"
export * from "./PriceCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports